import { createSelector } from 'reselect';
import { OrderAdditionalServiceGdsServiceServiceType, GdsServiceVipSubType } from '@websky/graphql';
import { checkoutSelectedServicesStateFactory } from '../../../../../Checkout/utils';
function getCardExtraServicesByTypesSelector(additionalServices) {
    var _a, _b;
    const servicesByType = {};
    (_b = (_a = additionalServices === null || additionalServices === void 0 ? void 0 : additionalServices.gdsServices) === null || _a === void 0 ? void 0 : _a.services) === null || _b === void 0 ? void 0 : _b.forEach(service => {
        const key = service.rfisc;
        let type = service.type;
        if (service.type === OrderAdditionalServiceGdsServiceServiceType.Vip) {
            const { subType } = service;
            if (subType === GdsServiceVipSubType.BusinessLounge ||
                subType === GdsServiceVipSubType.BusinessLoungeInternational) {
                type = OrderAdditionalServiceGdsServiceServiceType.BusinessLounge;
            }
        }
        if (!servicesByType[type]) {
            servicesByType[type] = {};
        }
        const existService = servicesByType[type][key];
        if (!existService || +existService.id < +service.id) {
            servicesByType[type][key] = service;
        }
    });
    return servicesByType;
}
function getSelectedServicesByIdSelector(selectedServices) {
    const selectedServicesById = {};
    for (const passengerId of Object.keys(selectedServices)) {
        const passengerServices = selectedServices[passengerId];
        for (const serviceId of Object.keys(passengerServices)) {
            if (selectedServicesById[serviceId]) {
                continue;
            }
            selectedServicesById[serviceId] = !!passengerServices[serviceId].length;
        }
    }
    return selectedServicesById;
}
function getAvailableCardExtraServicesTypesSelector(cardExtraServicesByTypes, selectedServicesById) {
    const availableCardExtraServicesTypes = {};
    for (const type of Object.keys(cardExtraServicesByTypes)) {
        const servicesByKey = cardExtraServicesByTypes[type];
        if (availableCardExtraServicesTypes[type] || !Object.keys(servicesByKey).length) {
            continue;
        }
        availableCardExtraServicesTypes[type] = Object.values(servicesByKey).some(service => service.canBeAdded || selectedServicesById[service.id]);
    }
    return availableCardExtraServicesTypes;
}
export function createCardExtraSelectors(getOrder) {
    const getAdditionalServices = createSelector(getOrder, order => order.additionalServices);
    const getSelectedServicesState = createSelector(getOrder, checkoutSelectedServicesStateFactory);
    const getCardExtraServicesByTypes = createSelector(getAdditionalServices, getCardExtraServicesByTypesSelector);
    const getSelectedServicesById = createSelector(getSelectedServicesState, getSelectedServicesByIdSelector);
    const getAvailableCardExtraServicesTypes = createSelector(getCardExtraServicesByTypes, getSelectedServicesById, getAvailableCardExtraServicesTypesSelector);
    return {
        getCardExtraServicesByTypes,
        getSelectedServicesById,
        getAvailableCardExtraServicesTypes
    };
}
